export const SystemCard = ({ notification, option }) => {
  // Извлекаем данные из notification
  const title = notification?.payload?.title || 'Системное уведомление';
  const message = notification?.payload?.message || notification?.payload?.text || '';
  const isNew = !notification?.seen;

  // Форматируем дату
  const formatDate = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    const now = new Date();
    const diff = now - date;
    const minutes = Math.floor(diff / (1000 * 60));
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    if (minutes < 1) return 'только что';
    if (minutes < 60) return `${minutes}м назад`;
    if (hours < 24) return `${hours}ч назад`;
    if (days < 7) return `${days}д назад`;

    return date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' });
  };

  return (
    <div className="text-white w-full flex flex-row min-h-[120px] items-start font-raleway relative py-4">
      <div className="flex flex-col w-full gap-2 ml-[16px] pr-[100px]">
        <p className="text-[16px] font-semibold leading-[24px]">{title}</p>
        <p className="text-[14px] font-normal text-gray-300">{message}</p>
        {notification?.createdAt && (
          <p className="text-[12px] text-gray-500 mt-1">{formatDate(notification.createdAt)}</p>
        )}
      </div>
      <div className="absolute top-[16px] right-1 flex flex-col justify-center w-[100px] items-end mr-3">
        {isNew && (
          <div
            className={`rounded-[400px] bg-[#A1F69E] w-[58px] h-[25px] flex items-center justify-center text-black font-semibold text-[12px]`}
          >
            NEW
          </div>
        )}
      </div>
    </div>
  );
};
